module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91 91"><path d="M45.5 0C20.4 0 0 20.4 0 45.5S20.4 91 45.5 91 91 70.6 91 45.5 70.6 0 45.5 0zm0 84C24.3 84 7 66.7 7 45.5S24.3 7 45.5 7 84 24.3 84 45.5 66.7 84 45.5 84zm0-73.2c-1.9 0-3.5 1.6-3.5 3.5V44L25.9 59.5c-1.4 1.3-1.4 3.6-.1 4.9.7.7 1.6 1.1 2.5 1.1.9 0 1.7-.3 2.4-1L47.9 48c.7-.7 1.1-1.6 1.1-2.5V14.3c0-1.9-1.6-3.5-3.5-3.5z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/clock.svg
// module id = 181
// module chunks = 1